module.exports = __webpack_public_path__ + "img/CEBU.9139eaa1.jpg";